module.exports = __webpack_public_path__ + "static/media/56.7feb3906.jpg";